import {Button, Form, Input, List, Popup, Toast} from "antd-mobile";
import axiosInstance from "../axiosInstance";
import {useEffect, useState} from "react";

const ProjectList = () => {
    const [form] = Form.useForm();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [popupVisible, setPopupVisible] = useState(false);
    const [editingProject, setEditingProject] = useState(null);

    useEffect(() => {
        fetchProjects();

    }, []);



    const fetchProjects = () => {
        setLoading(true);
        axiosInstance
            .get('/api/projects')
            .then((response) => {
                setProjects(response.data);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                Toast.show({ icon: 'fail', content: 'Failed to load projects' });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const addProject = (project) => {
        axiosInstance
            .post('/api/projects', project)
            .then(() => {
                fetchProjects();
            })
            .catch((error) => {
                console.error('Error adding project:', error);
                Toast.show({ icon: 'fail', content: 'Failed to add project' });
            });
    }

    const updateProject = (project) => {
        axiosInstance
            .put(`/api/projects/${project.id}`, project)
            .then(() => {
                fetchProjects();
            })
            .catch((error) => {
                console.error('Error updating project:', error);
                Toast.show({ icon: 'fail', content: 'Failed to update project' });
            });
    }

    const handleFormSubmit = (projectData) => {
    console.log('editingProject status:', editingProject); // 添加此日志查看状态

    if (editingProject !== null) {  // 明确判断是否为 null
        console.log('Updating existing project');
        updateProject({
            id: editingProject.id,
            ...projectData
        });
    } else {
        console.log('Adding new project');
        addProject(projectData);
    }
    closePopup();
}


    const showPopup = (project = null) => {
    setEditingProject(project);
    if (project) {
        form.setFieldsValue({
            name: project.name,
            bco_number: project.bco_number
        });
    } else {
        form.resetFields(); // 如果是新建，重置表单
    }
    setPopupVisible(true);
}

const closePopup = () => {
    setPopupVisible(false);
    setEditingProject(null);
    form.resetFields();
}

    return (
        <>
        <div className="project-list">
            <div className="project-list-header">
                <h2>Projects</h2>
                <Button onClick={fetchProjects}>Refresh</Button>
                <Button onClick={
                    () => {
                        setEditingProject(null);
                        showPopup();
                    }
                }>Add Project</Button>
            </div>
            <List>
                {projects.map((project) => (
                    <List.Item key={project.id} onClick={
                        () => {
                            showPopup(project);
                        }
                    }>
                        {project.name}
                    </List.Item>
                ))}
            </List>
        </div>

            <Popup
                visible={popupVisible}
                onMaskClick={closePopup}
                animationType="slide-up"
            >
                <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
    <Form.Item
        name="name"
        label="Project Name"
        rules={[{ required: true, message: 'Please enter project name' }]}
    >
        <Input placeholder="Project Name" />
    </Form.Item>
    <Form.Item
        name={'bco_number'}
        label="BCO number"
        rules={[{ required: true, message: 'Please enter BCO number' }]}
    >
        <Input placeholder="BCO number" />
    </Form.Item>
    <Form.Item>
        <Button block type="submit" color="primary">
            Submit
        </Button>
    </Form.Item>
</Form>
            </Popup>


</>

    );
}

export default ProjectList;